import { createSlice, Slice, PayloadAction } from '@reduxjs/toolkit';

/* eslint-disable no-param-reassign, quotes */
export const adminPopupSlice: Slice = createSlice({
    name: 'adminPopup',
    initialState: {
        title: '',
        subTitle: '',
        content: null,
        confirmation: '',
        actions: [],
        isOpen: false,
        type: '',
        jobId: '',
        icon: '',
        jobCompleted: false
    },
    reducers: {
        showPopup: (
            state,
            action: PayloadAction<{
                type: string;
                title?: string;
                subTitle?: string;
                content: any;
                confirmation: string;
                icon?: string;
                actions: { label: string; isEnabled: boolean; class: string; onclick: Function; buttonRef: any }[];
            }>
        ): void => {
            state.title = action.payload.title;
            state.subTitle = action.payload.subTitle;
            state.content = action.payload.content;
            state.confirmation = action.payload.confirmation;
            state.actions = action.payload.actions;
            state.isOpen = true;
            state.icon = action.payload.icon;
            state.type = action.payload.type;
        },
        onClose: (state): void => {
            state.isOpen = false;
        },
        resetAlert: (state, _action: PayloadAction<void>): void => {
            state.title = '';
            state.subtitle = '';
            state.content = null;
            state.confirmation = '';
            state.actions = [];
            state.isOpen = false;
        },
        showCancelStepper: (
            state,
            action: PayloadAction<{
                onConfirm: Function;
                onCancel: Function;
                title?: string;
                summary?: string;
                buttonText?: string;
            }>
        ): void => {
            state.title = action.payload.title || 'CancelAssignment';
            state.subTitle = 'AreYouSure';
            state.content = {
                summary: action.payload.summary || 'TheAssignmentProccessWillBeAborted'
            };
            state.type = 'information';
            state.confirmation = 'HowWouldYouLikeToContinue';
            state.actions = [
                {
                    label: 'Abort',
                    isEnabled: true,
                    class: 'learningPanelAdminCancel',
                    onClick: action.payload.onConfirm
                },
                {
                    label: action.payload.buttonText || 'ContinueAssignment',
                    isEnabled: true,
                    class: 'learningPanelAdminActionButton',
                    onClick: action.payload.onCancel
                }
            ];
            state.isOpen = true;
        },
        showFloatingProgress: (state, action: PayloadAction<{ jobId: number }>): void => {
            state.jobId = action.payload.jobId;
        },
        jobCompleted: (state, _action: PayloadAction<{}>): void => {
            state.jobCompleted = true;
        },
        jobStarted: (state, _action: PayloadAction<{}>): void => {
            state.jobCompleted = false;
        }
    }
});

export const { showPopup, onClose, resetAlert, showCancelStepper, showFloatingProgress, jobCompleted, jobStarted } =
    adminPopupSlice.actions;

type adminPopupSliceState = { adminPopup: any };
export const selectTitle = (state: adminPopupSliceState): string | undefined => state.adminPopup.title;
export const selectSubTitle = (state: adminPopupSliceState): string | undefined => state.adminPopup.subTitle;
export const selectContent = (state: adminPopupSliceState): any => state.adminPopup.content;
export const selectConfirmation = (state: adminPopupSliceState): string | undefined => state.adminPopup.confirmation;
export const selectActions = (state: adminPopupSliceState): any[] => state.adminPopup.actions;
export const selectIsOpen = (state: adminPopupSliceState): boolean => state.adminPopup.isOpen;
export const selectType = (state: adminPopupSliceState): string => state.adminPopup.type;
export const selectJobId = (state: adminPopupSliceState): number => state.adminPopup.jobId;
export const selectJobCompleted = (state: adminPopupSliceState): boolean => state.adminPopup.jobCompleted;

export const selectIcon = (state: adminPopupSliceState): string => state.adminPopup.icon;

export default adminPopupSlice.reducer;
